import { IMRespondingType } from '../types'
import { IMAncestorType } from '../types/reference'
import { PARAGRAPH_SPACING, wrapP } from '../../html_utility'
import { snakeKabobToTitleCase } from '../../../utility'
import { IM360Parser } from './IM360Parser'

export function respondingToStudentThinkingNodes(
  responding: IMRespondingType[] = [],
) {
  const value = responding
    .map(({ category, observation, response_description, references = [] }) => {
      const referencesString = references
        .map((ref) => {
          const ancestors = ['course', 'unit', 'lesson']
            .reduce<string[]>((acc, ancestor) => {
              const data = ref.ancestors[ancestor as IMAncestorType]
              if (!data) return acc
              return [...acc, data.ordinal_title ?? data.title]
            }, [])
            .join(', ')
          return `${ancestors}, ${ref.ordinal_title} ${ref.title}`
        })
        .join('<br>')
      return (
        wrapP('Observation') +
        wrapP(observation) +
        PARAGRAPH_SPACING +
        wrapP(snakeKabobToTitleCase(category)) +
        wrapP(response_description) +
        referencesString
      )
    })
    .join(PARAGRAPH_SPACING)
  if (!value) return []
  return [
    IM360Parser.getInstance().createNoteNode({
      title: 'Responding To Student Thinking',
      value,
      studentFacing: false,
    }),
  ]
}
